const controller = function(component){
    var self = this;

    this.init = function(){
        //Setup answers container
        self.clear();

        //Setup enable/disable switches
        var disabled = {};
        for(let g=0; g<component.question.config.groups.length; g++){
            var group = component.question.config.groups[g];

            disabled[group.id] = {};

            for(let i=0; i<group.inputs.length; i++){
                var input = group.inputs[i];
                disabled[group.id][input.id] = input.disabled ? true: false;
            }
        }
        component.disabled = disabled;      
        
        //Setup enable other
        self.clearOther();
    }

    this.setValue = function(group_id, valueArray){
        if( group_id && valueArray && typeof valueArray=='object' ){
            component.value[group_id] = valueArray;
        }else{
            console.error("setValue Error: ",{
                group_id: group_id,
                value: value
            })
        }
    }

    this.value_action = function(){
        return new Promise((resolve, reject)=>{
            
            var enableOther = component.enableOther;
            var enableThese = {};
            for(let group_id in enableOther){
                enableThese[group_id] = {};
                var group = enableOther[group_id];
                for(let input_value in group){
                    enableThese[group_id][input_value] = false;
                    var config = component.get_config(group_id, input_value);
                                            
                    if( component.value[group_id][input_value]!=null && (config.input.other===true) ){
                        enableThese[group_id][input_value] =  true;
                    }
                }
            }
            component.enableOther = enableThese;

            var other = component.other;
            for(let group_id in enableThese){
                var group = enableThese[group_id];
                for(let input_value in group){
                    var enabled = enableThese[group_id][input_value];
                                            
                    if(enabled===false){
                        other[group_id][input_value] = null;
                    }
                }
            }                
            resolve();
        })
    }

    this.clear = function(group_id, value){
        if(group_id && value){
            component.value[group_id][value] = null;
            self.clearOther(group_id, value);
        }else{
            var value = {}
            for(let g=0; g<component.question.config.groups.length; g++){
                var group = component.question.config.groups[g];
    
                value[group.id] = {};

                for(let i=0; i<group.inputs.length; i++){
                    var input = group.inputs[i];
                    value[group.id][input.id] = null;
                }
            }
            component.value = value;
            self.clearOther();
        }
        
    }

    this.setDisable = function(state, group_id, input_id){
        var config = component.get_config(group_id, input_id);
        var value = config.input.value;
        if(state===true){
            self.clear(group_id, value);
        }
        component.disabled[group_id][input_id] = state;
    }

    this.clearOther = function(group_id, value){
        if(group_id && value){
            component.other[group_id][value] = null;
            component.enableOther[group_id][value] = false;
        }else{
            //Setup 'other' fields
            var other = {}
            var enableOther = {}
            for(let g=0; g<component.question.config.groups.length; g++){
                var group = component.question.config.groups[g];
    
                other[group.id] = {};
                enableOther[group.id] = {};
                for(let i=0; i<group.inputs.length; i++){
                    var input = group.inputs[i];
                    enableOther[group.id][input.id] = false;
                    other[group.id][input.id] = null;
                }
            }
            component.other = other;
            component.enableOther = enableOther;
        }
    }
    
    this.init();    
}

export default controller;